import { ICreateChecklistServicoUseCase } from "../../../presentation/useCases/create/create_checklist_servico_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateChecklistServicoUseCase
 */

export class CreateChecklistServicoUseCase implements ICreateChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createChecklistServico(
    ativo: boolean,
    codigo: string,
    nroRevisao: string,
    descricao: string,
    tipoServico: number,
    unidade: string | null,
    campo1: string,
    campo2: string,
    campo3: string,
    campo4: string,
  ): Promise<void> {
    await this.repository.createChecklistServico(
      ativo,
      codigo,
      nroRevisao,
      descricao,
      tipoServico,
      unidade,
      campo1,
      campo2,
      campo3,
      campo4,
    );
  }
}
